module.exports = __webpack_public_path__ + "media/promo/lum2021/images/congr-7b820348bb297d65c4950db1268c7519.jpg";